import { maybe } from "shared/maybe"
import { getMode } from "shared/misc"

export const MODE = getMode(import.meta.env.MODE)
export const BASE_URL = import.meta.env.BASE_URL
export const GRAPHQL_URL = maybe(import.meta.env.C4_GRAPHQL_URL)
export const UPLOADS_URL = maybe(import.meta.env.C4_UPLOADS_URL)
export const IMAGE_URL = maybe(import.meta.env.C4_IMAGE_URL)
export const GRAPHQL_BATCH_MAX = Number.MAX_SAFE_INTEGER
export const GRAPHQL_BATCH_INTERVAL = 1
export const APP_NAME = "C4"
export const ASSET_DELIMITER = " / "
